import { Users, Trash2, Loader2, Hash } from 'lucide-react'
import { useTelegramGroups, useDeleteGroup, type TelegramBot, type TelegramGroup } from '@/api/hooks/useTelegram'
import { toast } from 'sonner'
import { BotSelector } from './BotSelector'

const typeBadge: Record<string, string> = {
  group: 'bg-blue-500/10 text-blue-400',
  supergroup: 'bg-purple-500/10 text-purple-400',
  channel: 'bg-green-500/10 text-green-400',
}

export function GroupsTab({ botId, bots, onBotChange }: { botId: string | null; bots: TelegramBot[]; onBotChange: (id: string) => void }) {
  const { data: groups, isLoading } = useTelegramGroups(botId)
  const deleteGroup = useDeleteGroup()

  const handleDelete = async (group: TelegramGroup) => {
    if (!confirm(`Sair do grupo "${group.title}"? O bot será removido do grupo.`)) return
    try {
      await deleteGroup.mutateAsync(group.id)
      toast.success('Grupo removido')
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  return (
    <div className="space-y-4">
      <BotSelector bots={bots} value={botId} onChange={onBotChange} />

      {!botId ? (
        <p className="text-sm text-muted-foreground">Adicione um bot primeiro na aba Bots</p>
      ) : isLoading ? (
        <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Carregando...</div>
      ) : !groups?.length ? (
        <div className="border border-dashed border-border rounded-lg p-8 text-center">
          <Users className="h-10 w-10 mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground">Nenhum grupo detectado</p>
          <p className="text-xs text-muted-foreground mt-1">Adicione o bot a um grupo no Telegram para ele aparecer aqui</p>
        </div>
      ) : (
        <div className="grid gap-3">
          {groups.map((group) => (
            <div key={group.id} className="flex items-center justify-between p-4 rounded-lg border border-border bg-card">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-accent flex items-center justify-center">
                  <Hash className="h-5 w-5 text-muted-foreground" />
                </div>
                <div>
                  <p className="font-medium">{group.title}</p>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground mt-0.5">
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${typeBadge[group.type] || 'bg-accent text-muted-foreground'}`}>{group.type}</span>
                    <span>{group.member_count.toLocaleString()} membros</span>
                    {group.joined_at && <span>Desde {new Date(group.joined_at).toLocaleDateString('pt-BR')}</span>}
                  </div>
                </div>
              </div>
              <button onClick={() => handleDelete(group)} className="p-2 text-muted-foreground hover:text-red-400 transition-colors" title="Sair do grupo">
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
